// Read a picked file as base64 (strips the `data:<mime>;base64,` prefix) plus its mime.
export function fileToBase64(file: File): Promise<{ dataBase64: string; mime: string }> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const res = String(reader.result);
      const comma = res.indexOf(',');
      resolve({ dataBase64: comma >= 0 ? res.slice(comma + 1) : res, mime: file.type || 'application/octet-stream' });
    };
    reader.onerror = () => reject(new Error('read_failed'));
    reader.readAsDataURL(file);
  });
}

export const UPLOAD_ACCEPT = 'application/pdf,image/png,image/jpeg';
